import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DataService } from '../../common-services/data.service';

export interface DialogData {
  title: string;
  content: string;
  pageType: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  constructor(
    private _dataService: DataService,
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  close() {
    this.dialogRef.close();
    if (this.data?.pageType)
      this._dataService.broadcast(this.data.pageType);
  }
}
